import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type IntegrationProviderLiteFragment = { id: string, name: string, provider: Types.IntegrationProviderEnum };


export type IntegrationProviderLiteFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const IntegrationProviderLiteFragmentDoc = /*#__PURE__*/ gql`
    fragment IntegrationProviderLite on IntegrationProviderType {
  id
  name
  provider
}
    `;